import { useEffect, useState } from 'react'
import { ImageOff } from 'lucide-react'
import { api } from '../lib/api'
import { cn } from '../lib/cn'

// A foto do almoxarifado vive em rota autenticada (GET /media/:id), então não dá
// para apontar o <img> direto: busca como blob e mostra por object URL.
export function MediaImage({
  mediaId,
  alt = '',
  className,
  onClick,
}: {
  mediaId: string | null | undefined
  alt?: string
  className?: string
  onClick?: () => void
}) {
  const [url, setUrl] = useState<string | null>(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    if (!mediaId) return
    let revoked = false
    let objectUrl: string | null = null
    setFailed(false)
    api.get(`/media/${mediaId}`, { responseType: 'blob' })
      .then((res) => {
        if (revoked) return
        objectUrl = URL.createObjectURL(res.data as Blob)
        setUrl(objectUrl)
      })
      .catch(() => { if (!revoked) setFailed(true) })
    return () => {
      revoked = true
      if (objectUrl) URL.revokeObjectURL(objectUrl)
      setUrl(null)
    }
  }, [mediaId])

  if (!mediaId || failed) {
    return (
      <div className={cn('flex items-center justify-center bg-gray-50 text-gray-300', className)}>
        <ImageOff className="h-4 w-4" />
      </div>
    )
  }

  if (!url) return <div className={cn('animate-pulse bg-gray-100', className)} />

  return (
    <img
      src={url}
      alt={alt}
      onClick={onClick}
      className={cn('object-cover', onClick && 'cursor-zoom-in', className)}
    />
  )
}
